import { render, staticRenderFns } from "./LoginTabs.vue?vue&type=template&id=b1d1a1e0&scoped=true&lang=html&"
import script from "./LoginTabs.vue?vue&type=script&lang=js&"
export * from "./LoginTabs.vue?vue&type=script&lang=js&"
import style0 from "./LoginTabs.vue?vue&type=style&index=0&id=b1d1a1e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d1a1e0",
  null
  
)

export default component.exports